// @ts-nocheck
import * as React from "react";

const CheckboxIndeterminate: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="M6 12.5v-1h12v1H6Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(CheckboxIndeterminate);
